import type { Tier } from './TierBadge';

/**
 * Map real account data to a verification tier. Only two states are backed by
 * real data today (the `verified` boolean); 'trusted' is never emitted until a
 * real `verificationTier` field exists on the account model.
 */
export function deriveTier(verified: boolean): Tier {
  return verified ? 'verified' : 'basic';
}
